import { motion, AnimatePresence } from "framer-motion";
import Menu from "../../components/Dashboard/Menu/Menu";
import Search from "../../components/Dashboard/Search";
import { ReactComponent as LoginRegisterBG } from "../../assets/images/workflow.svg";
import Button from "./Button";
import { NO_ACCESS_TYPES } from "../../utils/constants";
import AccessControl from "./AccessControl";
import Breadcrumbs from "./Breadcrumbs";
import NotificationsPopPanel from "../Dashboard/Notifications/NotificationsPopPanel";
import MobileMenuPopPanel from "../Dashboard/MobileMenuPopPanel";

function DashboardContainer(props) {
    const {
        children,
        title,
        titleIcon,
        actionButton,
        actionButtonOnClick,
        actionButtonText,
        actionButtonIcon,
        actionButtonPermission,
        extraElements,
    } = props;

    return (
        <>
            <div className="flex flex-row flex-1 gap-8 p-6 overflow-hidden">
                <Menu />
                <div className={"w-full z-20"}>
                    <div className={"flex flex-row items-center gap-4 md:gap-8"}>
                        {process.env.REACT_APP_FEATURE_ENABLEMENT_LEVEL <= 0 && <NotificationsPopPanel />}
                        <Search />
                        <MobileMenuPopPanel />
                    </div>
                    <Breadcrumbs />
                    <div className="col-span-full w-full">
                        <div className="flex items-center justify-between py-4 bg-blue-gray-100 z-30">
                            <div className="inline-flex items-center justify-center text-primary-600 h-12">
                                {titleIcon}
                                <h1 className="text-lg font-medium">{title}</h1>
                            </div>
                            {actionButton && (
                                <AccessControl
                                    requiredPermission={actionButtonPermission}
                                    noAccessType={NO_ACCESS_TYPES.BLANK}
                                >
                                    <Button
                                        onClick={actionButtonOnClick}
                                        text={actionButtonText}
                                        icon={actionButtonIcon}
                                        iconPositionLeft
                                        extraStyling={
                                            "text-white focus:ring-inset focus:ring-1 bg-secondary-500 " +
                                            "hover:bg-secondary-600 focus:outline-none focus:ring-secondary-500"
                                        }
                                    />
                                </AccessControl>
                            )}
                            {extraElements}
                        </div>
                        <div className={"z-10 mb-6"}>
                            <AnimatePresence>
                                <motion.div
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    {children}
                                </motion.div>
                            </AnimatePresence>
                        </div>
                    </div>
                </div>
            </div>
            <LoginRegisterBG
                className="opacity-10 absolute z-0 h-screen p-10"
                style={{
                    height: 500,
                    bottom: 0,
                    width: 700,
                    right: -0,
                    zIndex: -99999,
                }}
            />
        </>
    );
}

export default DashboardContainer;
